import pages from '../../../config/i18n.pages'
import locales from '../../../config/i18n.locales'

/**
 * Maps locale code to valid hreflang value using the iso field from i18n.locales.js
 */
const localeToHreflang = locales.reduce((map, locale) => {
  map[locale.code] = locale.iso ? locale.iso.toLowerCase() : locale.code

  return map
}, {})

const setList = payload => {
  let page
  const { routeName, param, data } = payload

  const baseUrl = process.env.BASE_URL
  const alternate = []

  page = routeName.split('___')[0]

  const locale = routeName.split('___')[1]
  switch (page) {
    case 'locale':
      page = 'index'
      break

    default:
      break
  }

  const defaultUrl = pages[`${page}`]['en'] ? `en${pages[`${page}`]['en']}` : `pt-br${pages[`${page}`]['pt-br']}`

  let defaultHref = `${baseUrl}/${defaultUrl}`
  if (page === 'index' && pages[`${page}`]['en']) {
    defaultHref = `${baseUrl}/${defaultUrl}`
  }

  const alternateDefault = {
    hid: 'alt-default',
    rel: 'alternate',
    href: defaultHref,
    hreflang: 'x-default',
  }

  if (param) {
    let code, exist

    exist = false

    code = 'fr'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'es'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'pt-br'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }
    code = 'en'
    if (data[code].length > 0) {
      exist = true
      alternateDefault.href = `${baseUrl}/${`${code}${pages[`${page}`][code]}`.replace('/:slug', '')}/${data[code]}`
    }

    exist ? alternate.push(alternateDefault) : null
  } else alternate.push(alternateDefault)

  const allowedLocales = ['pt-br', 'es', 'co', 'mx', 'la', 'en']

  const pagesVariants = Object.keys(pages[`${page}`]).filter(v => allowedLocales.includes(v))

  pagesVariants.map(variant => {
    if (variant) {
      const slug = param && data[variant].length > 0 ? `/${data[variant]}` : ''
      let href = `${baseUrl}/${variant}${pages[page][variant].replace('/:slug', '')}${slug}`

      // Override pt-br para apontar para education.hotmart.com
      if (variant === 'pt-br' && page === 'index') {
        href = 'https://education.hotmart.com/comeceavender'
      }

      const alternateObj = {
        hid: `alt-${variant}`,
        rel: 'alternate',
        href,
        hreflang: localeToHreflang[variant] || variant,
      }

      if (!param || (param && data[variant].length > 0)) {
        alternate.push(alternateObj)
      }
    }

    return true
  })

  return alternate
}

export default {
  setList,
}
